<template>
    <div v-if="komisiGrader">
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isPembayaran ? '' : (isKonfirmasi ? 'Konfirmasi' : 'Informasi') }} Pembayaran Grader</h5>
            </b-card-header>
            <b-card-body v-show="isKonfirmasi">
                <p>Pembayaran sebesar Rp. {{ pembayaran.nominal ? formatNumber(pembayaran.nominal * komisiGrader.total_bobot) : '-' }} kepada {{ komisiGrader.grader ? komisiGrader.grader : '-' }}.</p>
                <p>Dengan metode pembayaran {{ pembayaran.metode && pembayaran.metode.name ? pembayaran.metode.name.toUpperCase() : '-' }}.</p>
            </b-card-body>
            <b-card-body v-show="!isKonfirmasi">
                <div class="table-responsive">
                    <table class="table table-borderless">
                        <tr>
                            <th class="fit-column">Grader</th>
                            <td class="fit-column">:</td>
                            <th colspan="3" class="text-primary">{{ komisiGrader.grader }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Gudang</th>
                            <td class="fit-column">:</td>
                            <th colspan="3" class="text-primary">{{ komisiGrader.gudang }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Tanggal</th>
                            <td class="fit-column">:</td>
                            <th colspan="3" class="text-primary">{{ formatDate(komisiGrader.created_at) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Status</th>
                            <td class="fit-column">:</td>
                            <th colspan="3" class="text-primary">{{ komisiGrader.terbayar_pada ? 'Terbayar' : 'Pending' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Total Grading</th>
                            <td class="fit-column">:</td>
                            <th colspan="3" class="text-primary">{{ formatNumber(komisiGrader.total_bobot) }}</th>
                        </tr>
                        <tr v-for="(detail, index) in details">
                            <th class="fit-column">{{ index ? '' : 'Detail Grading' }}</th>
                            <td class="fit-column">{{ index ? '' : ':' }}</td>
                            <th class="text-primary">{{ detail.supplier ? detail.supplier.name : detail.supply_mode }}</th>
                            <th class="text-primary">{{ detail.grade ? detail.grade.name : '-' }}</th>
                            <th class="text-primary">{{ formatNumber(detail.bobot) }}</th>
                        </tr>
                        <tr v-if="isPembayaran">
                            <th class="fit-column">Fee per kg</th>
                            <td class="fit-column">:</td>
                            <td colspan="3">
                                <input v-validate="'required|min_value:0'" min="0" v-model="pembayaran.nominal" type="number" name="nominal" class="form-control">
                                <span class="text-danger">{{ errors.first('nominal') }}</span>
                            </td>
                        </tr>
                        <tr v-if="isPembayaran">
                            <th class="fit-column">Metode</th>
                            <td class="fit-column">:</td>
                            <td colspan="3">
                                <div class="input-group single mb-0 d-flex">
                                    <multiselect class='w-auto flex-grow-1' v-validate="'required'" name="metode" v-model="pembayaran.metode" :options="metodeOptions" :placeholder="'Pilih'" :searchable="true"
                                        label="value" track-by="name" :allowEmpty="false" :show-labels="false"></multiselect>
                                </div>
                                <span class="text-danger">{{ errors.first('metode') }}</span>
                            </td>
                        </tr>
                    </table>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="koreksi" type="button" class="btn btn-secondary">Koreksi</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="save" type="button" class="btn btn-primary mr-2">OK</button>
                <button :disabled="isLoading" v-if="!isKonfirmasi" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="isLoading" v-if="!isPembayaran" @click="print" type="button" class="btn btn-primary mr-2"><i class="fas fa-print"></i> Print</button>
                <button :disabled="isLoading" v-if="isPembayaran && !isKonfirmasi" @click="konfirmasi" type="button" class="btn btn-primary mr-2">Bayar</button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: "komisi-grader-viewer",

    props: {
        isPembayaran: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
        Multiselect,
    },

    data() {
        return {
            komisiGrader: null,
            pembayaran: null,
            details: [],
            metodeOptions: [
                {
                    name: 'tunai',
                    value: 'Tunai',
                },
                {
                    name: 'transfer',
                    value: 'Transfer',
                },
            ],
            isKonfirmasi: false,
        }
    },

    created() {
    },

    mounted() {
        if (this.value) {
            this.initPembayaran();
            this.getDetails();
        }
    },

    computed: {
    },

    watch: {
        value() {
            this.initPembayaran();
        }
    },

    methods: {
        initPembayaran() {
            let self = this;

            self.komisiGrader = Object.assign({}, self.value);
            self.pembayaran = Object.assign({}, {
                nominal: self.komisiGrader.nominal,
                metode: self.komisiGrader.metode,
            });
            let metodeIndex = self.metodeOptions.findIndex(option => option.name == self.pembayaran.metode);
            self.pembayaran.metode = Object.assign({}, self.metodeOptions[metodeIndex]);
        },

        getDetails() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            axios({
                method: 'get',
                url: '/api/komisi-graders/details?ids='+self.value.ids,
            })
            .then(function (response) {
                self.isLoading = false;
                self.$Progress.finish();
                self.details = response.data.data;
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        print() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/komisi-graders/print?tanggal='+self.komisiGrader.tanggal+'&gudang_id='+self.komisiGrader.gudang_id+'&grader_id='+self.komisiGrader.grader_id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('cancel');
            }
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        konfirmasi() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    self.isKonfirmasi = true;
                }
            });
        },

        save() {
            let self = this,
                data = Object.assign({}, {
                    id: self.komisiGrader.komisi_grader_id,
                    grader_id: self.komisiGrader.grader_id,
                    gudang_id: self.komisiGrader.gudang_id,
                    tanggal: self.komisiGrader.created_at,
                    nominal: self.pembayaran.nominal,
                    metode: self.pembayaran.metode.name,
                });

            self.isLoading = true;
            let api = '/api/komisi-graders/pembayaran';

            self.$Progress.start();
            axios({
                method: 'post',
                url: api,
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },
    },
}
</script>
<style>
.fit-column {
    width: 0.1%;
    white-space: nowrap;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
